class DawnMediaController {
  constructor(root) {
   this.root = root;
  this.mainContainer = root.querySelector(".custom-media-gallery__main");
  this.mainImage = root.querySelector(".gallery-main-image");
  this.thumbs = root.querySelectorAll(".thumb");

  this.mediaMap = window.__variantMediaMap || {};
  this.initialLoad = true;

  this.bindThumbClicks();
  this.bindVariantObserver();
  this.syncFromPageLoad();

  if (!this.mainImage.complete) {
  this.mainContainer.classList.add("loading");

  this.mainImage.addEventListener("load", () => {
    this.mainContainer.classList.remove("loading");
  }, { once: true });
}
  }

  /* -----------------------------
   * THUMBNAILS (your system)
   * ----------------------------- */
  bindThumbClicks() {
    this.thumbs.forEach(btn => {
      btn.addEventListener("click", () => {
        this.setActiveThumb(btn);
        this.setMainImage(btn.dataset.full);
      });
    });
  }

  setActiveThumb(btn) {
    this.thumbs.forEach(t => t.removeAttribute("aria-current"));
    btn.setAttribute("aria-current", "true");
  }
setMainImage(src) {
  if (!this.mainImage || !src) return;

  // Ignore same image
  if (this.mainImage.src === src) {
    this.initialLoad = false;
    return;
  }

  // Show loader
  this.mainContainer.classList.add("loading");

  // Initial load: no fade animation
  if (this.initialLoad) {
    this.mainImage.onload = () => {
      this.mainContainer.classList.remove("loading");
      this.mainImage.onload = null;
    };

    this.mainImage.src = src;
    this.initialLoad = false;
    return;
  }

  this.mainImage.classList.add("is-fading");

  const onLoad = () => {
    this.mainContainer.classList.remove("loading");
    this.mainImage.classList.remove("is-fading");
    this.mainImage.removeEventListener("load", onLoad);
  };

  this.mainImage.addEventListener("load", onLoad);

  this.mainImage.src = src;
}

  /* -----------------------------
   * 🔥 DAWN-CORRECT VARIANT HOOK
   * ----------------------------- */
  bindVariantObserver() {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const input = form.querySelector('input[name="id"]');
  if (!input) return;

  input.addEventListener("change", () => {
    this.applyVariantById(input.value);
  });

  const observer = new MutationObserver(() => {
    this.applyVariantById(input.value);
  });

  observer.observe(input, {
    attributes: true
  });
}

  /* -----------------------------
   * INITIAL LOAD SYNC
   * ----------------------------- */
  syncFromPageLoad() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input) return;

    this.applyVariantById(input.value);
  }

  /* -----------------------------
   * CORE LOGIC
   * ----------------------------- */
  applyVariantById(variantId) {
  const variant = this.mediaMap[variantId];
  if (!variant) return;

  if (variant.image && variant.image !== this.mainImage.src) {
    this.setMainImage(variant.image);
  }

  if (variant.media_id) {
    const match = this.root.querySelector(
      `[data-media-id="${variant.media_id}"]`
    );

    if (match) {
      this.setActiveThumb(match);
    }
  }

  this.syncUrl(variantId);
}

  /* -----------------------------
   * URL SYNC (?variant=)
   * ----------------------------- */
  syncUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.toString());
  }
}

/* -----------------------------
 * INIT
 * ----------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector(".custom-media-gallery");
  if (gallery) new DawnMediaController(gallery);
});


